module.exports = __webpack_public_path__ + "img/mxk_bg.580a4cd4.png";